'use client';
import Banner from '@/components/common/banner/Banner';
import LeftSidebarComponent from '@/features/jobs/components/sidebar/LeftSidebarComponent';
import TopCountWorks from '@/features/home/components/TopCountWorks';
import JobsMainList from './JobsMainList';

export default function JobsComponent({
  withSearchInput,
}: {
  withSearchInput?: boolean;
}) {
  return (
    <>
      <Banner type="horizontal" />
      <div className="grid min-w-0 grid-cols-1 gap-5 lg:grid-cols-4">
        <div
          className="hidden lg:block lg:col-span-1"
          style={{ '--top-spacing': '80px' } as React.CSSProperties}
        >
          <TopCountWorks />
          <LeftSidebarComponent />
        </div>
        <div className="col-span-3 min-w-0 lg:flex lg:gap-5">
          <div className="md:min-w-146 max-w-full flex-1">
            <JobsMainList showAdvancedSearchBtn={withSearchInput} />
          </div>
          <Banner type="vertical" />
        </div>
      </div>
    </>
  );
}
